import Vue from 'vue'
import jQuery from 'jquery'
import debounce from 'lodash/debounce'
// Nice to have finally method with promises
require('promise.prototype.finally').shim()
import axios from 'axios'
import $Db from '@/Db'
import jwtDecode from 'jwt-decode'
import router from './router'

/**
 * Set up all axios requests to contain the necessary account_id/portal version headers
 */
axios.interceptors.request.use((config) => {
  if (config.skipHeaders) {
    return config
  }
  config.headers = {
    ...(config.headers || {}),
    'Accept': 'application/json'
  }
  if (window.localStorage.token) {
    config.headers['Authorization'] = 'Bearer ' + window.localStorage.token
  }
  return config
})

axios.interceptors.response.use((response) => {
  $Db.handleResponse(response)
  return response
}, (error) => {
  $Db.handleError(error)
  console.log('error', error)
  throw error
})

let Session = new Vue({
  data () {
    return {
      loading: true,
      jwtExpiration: null,
      showLogin: false,
      user: {
        username: '',
        units: 1,
        firstname: '',
        lastname: '',
        cellnumber: ''
      }
    }
  },
  created () {
    jQuery(window).on('resize', debounce(this.resizeFunction, 400))

    setTimeout(() => {
      if (window.localStorage.token) {
        this.getUser()
      } else {
        this.loading = false
      }
    }, 200)

    // Polling to check JWT timeout
    setInterval(() => {
      if (this.jwtExpiration && this.jwtExpiration < (Date.now() / 1000)) {
        this.jwtExpiration = null
        window.localStorage.setItem('token', '')
      }
    }, 10000)
  },
  methods: {
    resizeFunction () {
      // this.screenWidth = jQuery(window).width()
      this.$emit('resize')
    },
    logout () {
      this.user = {}
      this.jwtExpiration = null
      window.localStorage.setItem('token', '')
      router.push({path: '/'})
      // window.localStorage.setItem('refresh_token', '')
    },
    getUser () {
      // Check the current JWT for an expiration ts.  This is needed to be authenticated.
      if (window.localStorage.token) {
        let decodedToken = jwtDecode(window.localStorage.token)
        console.log('dec', decodedToken)
        if (decodedToken && decodedToken.exp) {
          this.jwtExpiration = decodedToken.exp
        } else {
          console.log('invalid token', decodedToken)
          return
        }
      }

      this.loading = true
      return $Db.find('user', '', {force: true, params: {username: 'SELF'}}).then((user) => {
        this.user = user
        if (router.currentRoute.path === '/') {
          router.push({path: '/dashboard'})
          this.showLogin = false
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
})
window.session = Session
export default Session



// WEBPACK FOOTER //
// ./src/Session.js